module.exports = __webpack_public_path__ + "static/ccg-63ada050a167a7baa75c1984786fc041.png";